import React from 'react';
import {Redirect} from 'react-router-dom';

// Old bookmarks retain their period, preferences, source selection and fragment.
export const canonicalDigestLocation = location => ({
    ...location,
    pathname: location.pathname.replace(/^\/f\/daily-review(?=\/|$)/, '/f/digest')
});

export const LegacyDigestRedirect = ({location}) => <Redirect to={canonicalDigestLocation(location)} />;
